import Vue, { VueConstructor } from "vue";
import Vuetify from "vuetify/lib/framework";
import { Constructable } from "typedi";
import { bootstrap } from "@/core/bootstrap";
import { vuetify } from "@/core/vuetify";
import { CoreSymbols } from "@/core/core.symbols";
import { store } from "./store";
import { router } from "./router";
import { AppModule } from "./types/app-module";

export async function createApp(modules: Constructable<AppModule>[], entrypoint: VueConstructor): Promise<Vue> {
  Vue.use(Vuetify);

  await bootstrap(modules);

  Vue.$container.set(CoreSymbols.vuetify, vuetify);

  return new Vue({
    store,
    router,
    vuetify,
    render: (h) => h(entrypoint),
  });
}
